import React, { useEffect, useState } from "react";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import { Select, Button } from "antd";
import { DownloadOutlined } from "@ant-design/icons";

import { LOCAL_API_URL } from "../../../path";

import Card from "../../../Components/Card";
import Prize1 from "../../../Components/Svg/prize1";
import Prize2 from "../../../Components/Svg/prize2";
import Prize3 from "../../../Components/Svg/prize3";
import Columnchart from "../../../Components/Column";
import Usagegraph from "../../../Components/Usagegraph";
import User from "../../../Components/Svg/user";
import Post from "../../../Components/Svg/post";
import Table from "../../../Components/Tabledata";
import Tableheader from "../../../Components/TableHeader";
import Piechart2 from "../../../Components/Pie/piechart";

const Layout = ({
  Totalcount,
  TopStudent,
  PreferredGoals,
  PreferredActions,
  Monthlydata,

  // Filter API response
  FilterOptions,

  // Filter states
  BatchYear,
  setBatchYear,
  Shift,
  setShift,
  BranchCode,
  setBranchCode,
}) => {
  const { id, flyear } = useParams();
  const Navigate = useNavigate();

  // =========================================================
  // EXISTING DASHBOARD DATA
  // =========================================================
  const [Topactions, setTopactions] = useState([]);
  const [Yearlist, setYearlist] = useState([]);

  const handleExportCSV = async () => {
  try {
    const payload = {
      selected_college_id: id,

      ...(BatchYear?.length > 0 && {
        batch_year: BatchYear.map(Number),
      }),

      ...(Shift?.length > 0 && {
        shift: Shift,
      }),

      ...(BranchCode?.length > 0 && {
        branch_code: BranchCode,
      }),
    };

    console.log("Export CSV payload:", payload);

    const response = await fetch(
      `${LOCAL_API_URL}college/dashboard/top_students/export`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `bearer ${localStorage.getItem("SDG_TOKEN")}`,
        },
        body: JSON.stringify(payload),
      }
    );

    if (!response.ok) {
      throw new Error("Export failed");
    }

    const blob = await response.blob();

    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");

    link.href = url;
    link.download = "top_students.csv";

    document.body.appendChild(link);

    link.click();

    link.remove();

    window.URL.revokeObjectURL(url);

  } catch (error) {
    console.error("Export CSV error:", error);
  }
};

  // =========================================================
  // PREPARE DASHBOARD DATA + YEAR LIST
  // =========================================================
  useEffect(() => {
    // =======================================================
    // PREPARE FREQUENTLY USED ACTIONS DATA
    // =======================================================
    if (PreferredActions?.data?.body?.action_data) {
      let Data = [];

      PreferredActions?.data?.body?.action_data?.forEach((item) => {
        Data.push({
          name: item?.action_desc,
          data: [item?.total_count],
        });
      });

      setTopactions([...Data]);
    }

    // =======================================================
    // CREATE CALENDAR YEAR LIST
    //
    // This is different from Batch Year.
    //
    // This year is used for:
    // monthly_analysis
    // =======================================================
    const currentYear = new Date().getFullYear();
    const startYear = 2022;

    let yearOptions = [];

    for (
      let i = 0;
      i < currentYear - startYear + 1;
      i++
    ) {
      yearOptions.push({
        value: currentYear - i,
        label: currentYear - i,
      });
    }

    setYearlist([...yearOptions]);
  }, [PreferredActions]);

  return (
    <div className="h-full">

      {/* =========================================================
          BREADCRUMB
      ========================================================= */}
      <div className="p-2 py-1">
        <ul className="flex items-center">

          <li className="mx-1 font-semibold">
            <NavLink to="/college">
              Manage college
            </NavLink>
          </li>

          <li className="mx-1">
            <i className="fa-solid fa-angle-right"></i>
          </li>

          <li className="font-medium">
            {Totalcount?.data?.body?.college_name
              ?.split(/(\(Autonomous\))/i)
              .map((part, index) =>
                part.match(/^\(Autonomous\)$/i) ? (
                  <span key={index} className="text-xs font-semibold">
                    {part}
                  </span>
                ) : (
                  <span key={index}>{part}</span>
                )
              )}
          </li>

        </ul>
      </div>

      {/* =========================================================
          TITLE
      ========================================================= */}
      <p className="text-xl font-semibold px-2 py-3 text-Orange">
        College dashboard
      </p>

      {/* =========================================================
          FILTERS
      ========================================================= */}
      <div className="px-2 py-2 w-full">

        <div className="flex items-end w-full gap-4">

          {/* =====================================================
              BATCH YEAR
          ===================================================== */}
          <div>
            <label className="block text-sm font-semibold mb-1">
              Batch Year
            </label>

            <Select
              mode="multiple"
              allowClear
              placeholder="Select Batch Year"
              value={BatchYear}
              onChange={(value) => {
                setBatchYear(value);
              }}
              options={
                FilterOptions?.data?.body?.batch_year?.map((year) => ({
                  value: year,
                  label: year,
                })) || []
              }
              maxTagCount="responsive"
              style={{
                width: "220px",
                height: "40px",
              }}
            />
          </div>

          {/* =====================================================
              SHIFT
          ===================================================== */}
          <div>
            <label className="block text-sm font-semibold mb-1">
              Shift
            </label>

            <Select
              mode="multiple"
              allowClear
              placeholder="Select Shift"
              value={Shift}
              onChange={(value) => {
                setShift(value);
              }}
              options={
                FilterOptions?.data?.body?.shift?.map((item) => ({
                  value: item,
                  label:
                    item === "I"
                      ? "Morning"
                      : item === "II"
                      ? "Evening"
                      : item,
                })) || []
              }
              maxTagCount="responsive"
              style={{
                width: "180px",
                height: "40px",
              }}
            />
          </div>

          {/* =====================================================
              BRANCH CODE / DEPARTMENT
          ===================================================== */}
          <div>
            <label className="block text-sm font-semibold mb-1">
              Branch code / Department
            </label>

            <Select
              mode="multiple"
              allowClear
              placeholder="Select Course / Department"
              value={BranchCode}
              onChange={(value) => {
                setBranchCode(value);
              }}
              options={(() => {
                const branchMap = new Map();

                (
                  FilterOptions?.data?.body?.branch_code || []
                ).forEach((item) => {
                  const code = item?.branch_code;
                  const programme = item?.name_of_programme;

                  if (!code) {
                    return;
                  }

                  if (!branchMap.has(code)) {
                    branchMap.set(code, []);
                  }

                  if (
                    programme &&
                    !branchMap.get(code).includes(programme)
                  ) {
                    branchMap.get(code).push(programme);
                  }
                });

                return Array.from(branchMap.entries()).map(
                  ([code, programmes]) => ({
                    value: code,
                    label:
                      programmes.length > 0
                        ? `${code} - ${programmes.join(", ")}`
                        : code,
                  })
                );
              })()}
              maxTagCount="responsive"
              style={{
                width: "300px",
                height: "40px",
              }}
            />
          </div>

          {/* =====================================================
              EXPORT CSV
          ===================================================== */}
          {/* EXPORT CSV */}
          <div className="ml-auto mr-3">
            <Button
              type="primary"
              icon={<DownloadOutlined />}
              onClick={handleExportCSV}
              style={{
                height: "36px",
                backgroundColor: "#1677ff",
                borderColor: "#1677ff",
                color: "#ffffff",
                fontWeight: "500",
                fontSize: "13px",
                paddingLeft: "14px",
                paddingRight: "14px",
                borderRadius: "6px",
                marginRight: "10px",
              }}
            >
              Export CSV
            </Button>
          </div>

        </div>

      </div>

      {/* =========================================================
          CARD AND SCORE BOARD
      ========================================================= */}
      <div className="p-2 w-full flex items-stretch">
        <div className="w-full flex items-stretch justify-around">

          {/* TOTAL STUDENTS */}
          <div className="w-[50%] mx-1">
            <Card
              bg="bg-Orange"
              count={
                Totalcount?.data?.body?.total_reg_count || ""
              }
              icon={<User />}
              title="Total students participated"
            />
          </div>

          {/* TOTAL JOURNALS */}
          <div className="w-[50%] mx-1">
            <Card
              bg="bg-Navy"
              count={
                Totalcount?.data?.body?.total_journal_count || ""
              }
              icon={<Post />}
              title="Total journal entries"
            />
          </div>

        </div>
      </div>

      {/* =========================================================
          TOP STUDENTS + ACTIONS
      ========================================================= */}
      <div className="w-full flex items-start p-2">

        <div className="w-full mx-1 flex items-start">

          {/* =====================================================
              TOP 3 STUDENTS
          ===================================================== */}
          <div className="w-[50%]">
            <div className="w-full rounded-md shadow-xl border-2 border-[#ccd9c5] p-2">

              <Tableheader title="Top 3 students" />

              <div className="w-full pt-4">

                <Table
                  heading={[
                    "Position",
                    "Register No",
                    "Name",
                    "Journal Posted",
                  ]}
                  loading={TopStudent?.loading}
                >

                  {TopStudent?.data?.body?.length > 0 && (
                    <tbody>
                      {TopStudent?.data?.body?.map(
                        (item, index) => {
                          return (
                            <tr
                              key={index}
                              className="w-full grid grid-cols-4 px-1 py-1"
                            >

                              <td className="text-left flex items-center">
                                <span className="mr-1 font-bold">
                                  {item?.place}
                                  {item?.place === 1
                                    ? "st"
                                    : item?.place === 2
                                    ? "nd"
                                    : item?.place === 3
                                    ? "rd"
                                    : "th"}
                                </span>

                                {item?.place === 1 && (
                                  <Prize1 />
                                )}

                                {item?.place === 2 && (
                                  <Prize2 />
                                )}

                                {item?.place === 3 && (
                                  <Prize3 />
                                )}
                              </td>
                              <td className="text-center">
                                  {item?.regisno}
                              </td>
                                                              

                              <td className="text-center">
                                {item?.user_full_name}
                              </td>

                              <td className="text-center">
                                {item?.journal_count}
                              </td>

                            </tr>
                          );
                        }
                      )}
                    </tbody>
                  )}

                  {!TopStudent?.data?.body?.length && (
                    <tbody>
                      <tr className="w-full grid grid-cols-4 px-1 py-1">

                        <td></td>
                        <td></td>


                        <td className="text-center font-semibold my-2">
                          No Data
                        </td>

                        <td></td>

                      </tr>
                    </tbody>
                  )}

                </Table>

              </div>
            </div>
          </div>

          {/* =====================================================
              FREQUENTLY USED ACTIONS
          ===================================================== */}
          <div className="w-[50%] ml-2 shadow-xl border-2 border-[#ccd9c5] rounded-md p-3">

            <div className="w-[96%]">

              <p className="my-1 font-semibold text-lg">
                Frequently used Action points
              </p>

              {PreferredActions?.data?.body?.action_data && (
                <Columnchart
                  data={Topactions}
                  horizontal={true}
                  title="Actions"
                />
              )}

              {!PreferredActions?.data?.body?.action_data?.length && (
                <p className="text-center font-semibold my-2">
                  No Data
                </p>
              )}

            </div>
          </div>

        </div>

        {/* =====================================================
            GOAL DETAIL
        ===================================================== */}
        <div className="w-[50%] mx-1 hidden">

          <div className="p-2 rounded-md bg-white shadow-xl border-2 border-[#ccd9c5]">

            <p className="font-semibold text-lg">
              SDG goals preferred by students
            </p>

            {!PreferredGoals?.data?.body?.goal_data?.length && (
              <p className="text-center font-semibold my-2">
                No Data
              </p>
            )}

            {PreferredGoals?.data?.body?.goal_data && (
              <div className="w-full py-2">

                {PreferredGoals?.data?.body?.goal_data?.map(
                  (item, index) => {
                    return (
                      <div
                        key={index}
                        className="w-full grid grid-cols-7 content-center items-center my-2"
                        title={item?.goal_title}
                      >

                        <div className="col-span-3 flex items-center">

                          <img
                            src={item?.goal_icon}
                            alt={item?.goal_title}
                            className={`w-[50px] bg-[${item?.icon_color}] aspect-square object-contain p-2 rounded-md`}
                          />

                          <p className="pl-2 text-sm">
                            {item?.goal_title}
                          </p>

                        </div>

                        <div className="rounded-full bg-[#ccc5] overflow-hidden h-[15px] col-span-3 mx-1 p-1">

                          <div
                            className={`h-full w-[${item?.percent}] bg-[${item?.icon_color}] rounded-full`}
                          ></div>

                        </div>

                        <p className="col-span-1 px-1 text-sm font-medium text-left">

                          {item?.user_count}/
                          {
                            PreferredGoals?.data?.body
                              ?.total_user
                          }

                        </p>

                      </div>
                    );
                  }
                )}

              </div>
            )}

          </div>
        </div>

      </div>

      {/* =========================================================
          SDG GOALS
      ========================================================= */}
      <p className="font-semibold text-lg px-2">
        SDG goals preferred by students
      </p>

      <div className="my-4 w-full">

        <Piechart2
          data={PreferredGoals?.data?.body?.goal_data}
          collegeId={id}
          BatchYear={BatchYear}
          Shift={Shift}
          BranchCode={BranchCode}
        />

      </div>

      {/* =========================================================
          JOURNAL COUNT
      ========================================================= */}
      <div className="mx-1 w-[80%] max-w-[1000px]">

        <p className="px-2 text-md font-medium">
          Journal count -{" "}

          <select
            name=""
            id=""
            value={flyear}
            onChange={(e) => {
              Navigate(
                `/college/${id}/${e.target.value}`
              );
            }}
          >

            {Yearlist?.map((item) => {
              return (
                <option
                  key={item?.value}
                  value={item?.value}
                >
                  {item?.label}
                </option>
              );
            })}

          </select>

        </p>

        {!Monthlydata?.data?.body?.length && (
          <p className="text-center font-semibold my-2">
            No Data
          </p>
        )}

        {Monthlydata?.data?.body && (
          <Usagegraph
            data={Monthlydata?.data?.body}
          />
        )}

      </div>

    </div>
  );
};

export default Layout;